import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { CookieSetting } from "cookiesetting-component";
import LOPage from './components/Loinfo/Loinfo';
import ErrorPage from './components/error/ErrorPage';
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";


const Home = lazy(() => import("./Home"));
function App() {

  const isProduction = process.env.NODE_ENV === "production";
 
  
  return (
    <CacheBuster
    currentVersion={appversion.version}
    isEnabled={isProduction} 
    isVerboseMode={false} 
    metaFileDirectory={"."} 
  >
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    <>
    <Router>
      <Routes>
       <Route exact path="/renovation/:agentName" element={<LOPage />} />
      </Routes>
    </Router>
    
  </> 
    </CacheBuster>
  );
}

export default App;
